import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import ChessLeadership from "@/pages/ChessLeadership";
import Newsroom from "@/pages/Newsroom";
import Videos from "@/pages/Videos";
import { Companies, CompanyDetail } from "@/pages/Companies";
import MediaKit from "@/pages/MediaKit";
import { ThoughtLeadership, ArticleDetail } from "@/pages/ThoughtLeadership";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import Speaking from "@/pages/Speaking";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function AdminLayout({ children }) {
  return <div className="App"><ScrollToTop />{children}</div>;
}

function PublicLayout({ children }) {
  return (
    <div className="App">
      <ScrollToTop />
      <Header />
      {children}
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin/login" element={<AdminLayout><AdminLogin /></AdminLayout>} />
        <Route path="/admin" element={<AdminLayout><AdminDashboard /></AdminLayout>} />
        <Route path="/*" element={
          <PublicLayout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/chess-leadership" element={<ChessLeadership />} />
              <Route path="/news" element={<Newsroom />} />
              <Route path="/videos" element={<Videos />} />
              <Route path="/companies" element={<Companies />} />
              <Route path="/companies/:slug" element={<CompanyDetail />} />
              <Route path="/thought-leadership" element={<ThoughtLeadership />} />
              <Route path="/thought-leadership/:slug" element={<ArticleDetail />} />
              <Route path="/media-kit" element={<MediaKit />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/speaking" element={<Speaking />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={
                <main className="min-h-[60vh] flex items-center justify-center text-center px-6">
                  <div>
                    <div className="eyebrow mb-3">404</div>
                    <h1 className="serif-title text-5xl text-[#0a1628] mb-4">Page not found.</h1>
                    <a href="/" className="link-underline text-[13px] tracking-[0.18em] uppercase">← Return home</a>
                  </div>
                </main>
              } />
            </Routes>
          </PublicLayout>
        } />
      </Routes>
    </BrowserRouter>
  );
}
